import React, { useState, useEffect, useRef } from "react";
import { DownOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import DropdownMenu from "../DropdownMenu/DropdownMenu";
import "./HeaderCategories.css";

function HeaderCategories() {
  const [coursesMenuOpen, setCoursesMenuOpen] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target) && 
          buttonRef.current && !buttonRef.current.contains(event.target)) {
        setCoursesMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleCoursesMenu = (e) => {
    e.stopPropagation();
    setCoursesMenuOpen(prev => !prev);
  };

  const handleNavigateToCourses = (coursePath) => {
    navigate("/courses", { state: { filter: coursePath } });
    setCoursesMenuOpen(false);
  };

  return (
    <div className="header-categories-container">
      <div 
        ref={buttonRef}
        onClick={toggleCoursesMenu} 
        className={`courses-drop-down ${coursesMenuOpen ? "active" : ""}`}
        aria-expanded={coursesMenuOpen}
        aria-haspopup="true"
      >
        <span className="courses-categories">Classes</span>
        <DownOutlined className={`down-arrow-courses ${coursesMenuOpen ? "rotate" : ""}`} />
      </div>
      {coursesMenuOpen && (
        <div ref={menuRef} className="dropdown-wrapper">
          <DropdownMenu 
            onItemClick={handleNavigateToCourses} 
            closeMenu={() => setCoursesMenuOpen(false)}
          />
        </div>
      )}
    </div>
  );
}

export default HeaderCategories;